import React, { Component } from "react";
import PropTypes from "prop-types";
import Icon from "./Icon";
import TravelPlannerBrands from "../../enums";

export default class Sharing extends Component {
  static propTypes = {
    print: PropTypes.object,
    mail: PropTypes.object,
    whatsapp: PropTypes.object,
    logo: PropTypes.object,
  };
  render() {
    const { print, mail, whatsapp, logo, className } = this.props;

    if (mail) {
      mail.messageText = mail.messageText.replace(/\n/g, "%0D");
    }
    if (whatsapp) {
      whatsapp.href = `whatsapp://send?text=${whatsapp.messageText}`;
    }

    return (
      <div className={`${className ? className : ""} shares shares--right`}>
        <ul className="shares__list">
          {!logo ? null : (
            <li className="shares__item">
              <a className="btn btn--circle btn--circle--timetable-page btn--circle--no-hover">
                <Icon
                  iconName={logo.logoName}
                  title={
                    logo.buttonText + " " + TravelPlannerBrands[logo.logoName]
                  }
                />
              </a>
            </li>
          )}
          {!print ? null : (
            <li className="shares__item">
              <button
                className="btn btn--circle btn--circle--timetable-page"
                onClick={this.print}
              >
                <Icon iconName="print" title={print.buttonText} />
              </button>
            </li>
          )}
          {!mail ? null : (
            <li className="shares__item">
              <a
                className="btn btn--circle btn--circle--timetable-page"
                href={`mailto:?subject=${mail.subjectText}&body=${mail.messageText}`}
              >
                <Icon iconName="mail" title={mail.buttonText} />
              </a>
            </li>
          )}
          {!whatsapp ? null : (
            <li className="shares__item mobile-only">
              <a
                className="btn btn--circle btn--circle--timetable-page"
                href={whatsapp.href}
              >
                <Icon iconName="whatsapp" title={whatsapp.buttonText} />
              </a>
            </li>
          )}
        </ul>
      </div>
    );
  }

  print = () => {
    window.print();
  };
}



// WEBPACK FOOTER //
// ./src/components/Common/Sharing.js